/**
 * Tab strip for filtering an attempt's actions by category (Requires attention, All, per-category).
 */
import { ActionCategory, IActionTab } from '../action-categories';

interface IActionFilterTabsProps {
    tabs: IActionTab[];
    active: ActionCategory;
    onChange: (category: ActionCategory) => void;
}

const ActionFilterTabs: React.FC<IActionFilterTabsProps> = ({ tabs, active, onChange }) => {
    return (
        <div className="action-filter-tabs">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    className={`action-filter-tabs__tab${tab.id === active ? ' action-filter-tabs__tab--active' : ''}${
                        tab.id === 'requires_attention' && tab.count > 0 ? ' action-filter-tabs__tab--attention' : ''
                    }`}
                    onClick={() => onChange(tab.id)}
                >
                    {tab.label}
                    <span className="action-filter-tabs__count">{tab.count}</span>
                </button>
            ))}
        </div>
    );
};

export default ActionFilterTabs;
